import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as routing from '../constants/Routing';
import { useSessionLogout } from '../hooks/session/useSessionLogout';

export const Logout = () => {
  const { run: logout, success: loggedOut } = useSessionLogout();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (loggedOut) {
      queryClient.invalidateQueries([`user_is_logged`]);
      navigate(routing.AUTH);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedOut]);

  return null;
};
